import React, { Component } from 'react';

export class DropdownFieldView extends Component {


  render() {
    let {
      intl,
      translation,
      input,
      required,
      label,
      list = [],
      activeOnly = true,
      idField = 'id',
      displayField = 'name',
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }
    
    const requiredClass = required ? 'required' : '';

    let content;


    const optionList = list.reduce((accumulator = [], item) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionId = idVal;
          const optionValue = idVal;
          const optionLabel = item[displayField];

          if(input.value === optionValue){
            content = optionLabel;
          }

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push((
                <option key={optionId} value={optionValue}>{optionLabel}</option>
              ));
            }
          }
          else {
            accumulator.push((
              <option key={optionId} value={optionValue}>{optionLabel}</option>
            ));
          }
        }
      }

      return accumulator;
    }, []);

    console.log("optionList", optionList);

      return (
        <div className={`${requiredClass} field`}>
          <label>{label}</label>
          <div>{content}</div>
          <div>
            <input type="hidden" name={input.name} value={input.value}/>
          </div>
        </div>
      );



  }
}
